import React from 'react';

import { usePromotePageData } from 'src/app/pages/promote/pageContext';
import { PolicyInfo as SharedPolicyInfo } from 'src/app/shared/components/payments';

export const PolicyInfo: React.FC = () => {
	const {
		data: {
			featureConfigs: { useDonationLanguage },
		},
	} = usePromotePageData();

	return <SharedPolicyInfo useDonationLanguage={useDonationLanguage} />;
};
